import type { ReactNode } from 'react';
import { useState } from 'react';

type Props = {
  defaultValue?: boolean;
  children: (
    toggled: boolean,
    onToggle: (value?: boolean) => void,
  ) => ReactNode;
};

export function ToggleHelperContainer({
  defaultValue = false,
  children,
}: Props) {
  const [toggled, setToggled] = useState<boolean>(defaultValue);

  return children(toggled, (value) =>
    setToggled((wasToggled) =>
      typeof value === 'boolean' ? value : !wasToggled,
    ),
  );
}
